import React from 'react';
import Nav from "../../components/nav";
import DetailProfile from "../../components/profile/detailProfile";

const Profile = () => {
    return (
        <div>
            <Nav/>
            <DetailProfile/>
        </div>
    );
};

export default Profile;